import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './YoYField.module.scss'

export const YoYField = () => {
  return (
    <span className={styles.yoyHeader}>
      <Translation text="jbp-hrtargets-yoy" span actionsInside />
    </span>
  )
}
